videojs.addLanguage('ko', {
  "Audio Player": "오디오 플레이어",
  "Video Player": "비디오 플레이어",
  "Play": "재생",
  "Pause": "일시중지",
  "Replay": "다시 재생",
  "Current Time": "현재 시간",
  "Duration": "지정 기간",
  "Remaining Time": "남은 시간",
  "Stream Type": "스트리밍 유형",
  "LIVE": "라이브",
  "Loaded": "로드됨",
  "Progress": "진행",
  "Progress Bar": "진행 표시줄",
  "progress bar timing: currentTime={1} duration={2}": "{2} 중 {1}",
  "Fullscreen": "전체 화면",
  "Non-Fullscreen": "전체 화면 해제",
  "Mute": "음소거",
  "Unmute": "음소거 해제",
  "Playback Rate": "재생 비율",
  "Subtitles": "서브타이틀",
  "subtitles off": "서브타이틀 끄기",
  "Captions": "자막",
  "captions off": "자막 끄기",
  "Chapters": "챕터",
  "Descriptions": "제품 설명",
  "descriptions off": "제품 설명 끄기",
  "Audio Track": "오디오 트랙",
  "Volume Level": "볼륨 레벨",
  "You aborted the media playback": "비디오 재생을 취소했습니다.",
  "A network error caused the media download to fail part-way.": "네트워크 오류로 인하여 비디오 일부를 다운로드하지 못 했습니다.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "비디오를 로드할 수 없습니다. 서버 혹은 네트워크 오류 때문이거나 지원되지 않는 형식 때문일 수 있습니다.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "비디오 재생이 취소됐습니다. 비디오가 손상되었거나 비디오가 사용하는 기능을 브라우저에서 지원하지 않는 것 같습니다.",
  "No compatible source was found for this media.": "비디오에 호환되지 않는 소스가 있습니다.",
  "The media is encrypted and we do not have the keys to decrypt it.": "미디어는 암호화되어 있으며 이를 해독할 키를 갖고 있지 않습니다.",
  "Play Video": "영상 재생",
  "Close": "닫기",
  "Close Modal Dialog": "대화 상자 닫기",
  "Modal Window": "모달 창",
  "This is a modal window": "모달 창입니다",
  "This modal can be closed by pressing the Escape key or activating the close button.": "이 모달은 Esc 키를 누르거나 닫기 버튼을 활성화하여 닫을 수 있습니다.",
  ", opens captions settings dialog": ", 캡션 설정 대화 상자가 열립니다",
  ", opens subtitles settings dialog": ", 자막 설정 대화 상자가 열립니다",
  ", opens descriptions settings dialog": ", 설명 설정 대화 상자가 열립니다",
  ", selected": ", 선택됨",
  "captions settings": "캡션 설정",
  "subtitles settings": "자막 설정",
  "descriptions settings": "설명 설정",
  "Text": "텍스트",
  "White": "화이트",
  "Black": "블랙",
  "Red": "레드",
  "Green": "그린",
  "Blue": "블루",
  "Yellow": "옐로우",
  "Magenta": "마젠타",
  "Cyan": "씨엉",
  "Background": "배경",
  "Window": "창",
  "Transparent": "투명",
  "Semi-Transparent": "반투명",
  "Opaque": "불투명",
  "Font Size": "폰트 크기",
  "Text Edge Style": "텍스트 가장자리 스타일",
  "None": "없음",
  "Uniform": "균일",
  "Font Family": "폰트 모음",
  "Proportional Sans-Serif": "비례 산세리프체",
  "Monospace Sans-Serif": "고정폭 산세리프체",
  "Proportional Serif": "비례 세리프체",
  "Monospace Serif": "고정폭 세리프체",
  "Small Caps": "소문자",
  "Reset": "리셋",
  "restore all settings to the default values": "모든 설정을 기본값으로 복원",
  "Done": "완료",
  "Caption Settings Dialog": "캡션 설정 대화 상자",
  "Beginning of dialog window. Escape will cancel and close the window.": "대화창 시작. Esc 키를 누르면 취소되고 창이 닫힙니다.",
  "End of dialog window.": "대화창 종료",
  "{1} is loading.": "{1}이(가) 로딩 중입니다.",
  "Exit Picture-in-Picture": "Picture-in-Picture 종료",
  "Picture-in-Picture": "Picture-in-Picture"
});